import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/LandingHome.jsx";
import NewItem from "./pages/NewItem";
import Layout from "./components/Layout/Layout";
import ItemEdit from "./pages/ItemEdit";
import ItemView from "./pages/ItemView";
import userService from "./utils/userService";
import LoginTest from "./pages/Login";
import SignupTest from "./pages/Signup";
import FindFlorist from "./pages/FindFlorist.jsx";
import Chat from "./pages/Chat"




function App() {

  const [items, setItems] = useState([]);
  const [user, setUser] = useState({});

  const handleSignupOrLogin = () => {
    setUser(userService.getUser())
}

const handleLogout = () => {
    userService.logout();
    setUser(null)
}

  useEffect(() => {
    fetch(`${process.env.REACT_APP_PIF_API_URL}/item/`)
      .then(res => res.json())
      .then(items => setItems(items));
  }, []);





  const addItem = (item) => {
    setItems([...items, item]);
  };
  

  const updateItemState = (id) => {
    setItems(items.filter((item) => item._id !== id));
  };

  

  return (
    
    <Layout user={user} setUser={setUser} handleLogout={handleLogout}>
      <Routes>
      <Route
          path="/"
    
          element={
            <Home items={items} updateItemState={updateItemState} user={user} />
          }
        />
      <Route path="/signup" element={<SignupTest handleSignupOrLogin={handleSignupOrLogin}/>}/>
      <Route path="/login" element={<LoginTest handleSignupOrLogin={handleSignupOrLogin} setUser={setUser} />} />
       
       
        <Route path="/new-item" element={<NewItem addItem={addItem} />} />
        <Route
          path="/item/edit/:id/"
          element={<ItemEdit setItems={setItems} />}
        />
        <Route path="/item/:id" element={<ItemView updateItemState={updateItemState} items={items} />} />
        
      <Route path="/findflorist" element={<FindFlorist />}/>
      <Route path="/chat" element={<Chat />} />
      </Routes>
    </Layout>
  );
}

export default App;
